import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button, Box } from "@mui/material";

const GreenBeanAddButtonActions = ({ onCancel, onAdd }) => {
  const { t } = useTranslation();

  return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          gap: 1.5,
        }}
      >
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            flex: 2,
            borderColor: "#ccc",
            color: "#aaa",
          }}
        >
          {t('button.cancel')}
        </Button>
        <Button
          onClick={onAdd}
          variant="contained"
          color="primary"
          sx={{
            flex: 8,
            backgroundColor: "#003399",
          }}
        >
          {t('button.registration')}
        </Button>
      </Box>
  );
};
GreenBeanAddButtonActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default GreenBeanAddButtonActions;
